module.exports = __webpack_public_path__ + "img/app2.ec48e176.jpg";